import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
import { failStatus, StatusRequest, successStatus } from '../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class ActiveCartAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {}

  clearPoLines(cartId: string): Observable<StatusRequest> {
    const url = this.occEndPointService.buildUrl('clearPoLines', { urlParams: { cartId } });

    return this.http.post(url, {}).pipe(
      map(() => ({
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  updateNotes(cartId: string, orderEntryCode: number, notes: string): Observable<StatusRequest> {
    const url = this.occEndPointService.buildUrl('notes', { urlParams: { cartId } });

    return this.http.post(url, { orderEntryCode, notes }).pipe(
      map(() => ({
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  updateWarehouse(cartId: string, orderEntryCode: number, warehouseCode: string): Observable<StatusRequest> {
    const url = this.occEndPointService.buildUrl('warehouse', { urlParams: { cartId } });

    return this.http.post(url, { orderEntryCode, warehouseCode }).pipe(
      map(() => ({
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  updateShipDate(cartId: string, orderEntryCode: number, shippingDate: Date | string): Observable<StatusRequest> {
    const url = this.occEndPointService.buildUrl('shipDate', { urlParams: { cartId } });
    let formattedDate: string;

    if (shippingDate instanceof Date) {
      formattedDate = shippingDate.toISOString().split('T')[0];
    } else {
      formattedDate = shippingDate;
    }

    return this.http.post(url, { orderEntryCode, shippingDate: formattedDate }).pipe(
      map(() => ({
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  updatePoLine(cartId: string, orderEntryCode: number, poLine: string): Observable<StatusRequest> {
    const url = this.occEndPointService.buildUrl('poLine', { urlParams: { cartId } });

    return this.http.post(url, { orderEntryCode, poLine }).pipe(
      map(() => ({
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }
}
